<template>
  <div class="content-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <h2 class="content-header-title" style="border-right: none;">{{project.short_name}} ⇝ Пакеты шаблонов</h2>
      <button class="compose btn btn-primary" @click="newRecord()">Добавить</button>
    </div>

    <div class="card">
      <div class="card-header p-0">
        <div class="d-flex justify-content-between w-100">
          <div class="input-group input-group-merge shadow-none m-0 flex-grow-1">
            <div class="input-group-prepend">
              <span class="input-group-text border-0">
                <font-awesome-icon icon="fas fa-search" />
              </span>
            </div>
            <input type="text" @input="search()" v-model="searchQuery" class="form-control files-filter border-0 bg-transparent" placeholder="Поиск" />
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body h-100" style="padding: 0;">
        <div class="table-striped">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 5%;">#</th>
                <th style="width: 40%;">Наименование</th>
                <th style="width: 50%;">Шаблоны</th>
                <th style="width: 5%;">Действия</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="packs.length > 0">
                <tr v-for="(pack, index) in packs">
                  <td>{{index + 1}}</td>
                  <td>{{pack.name}}</td>
                  <td>
                    <ul v-for="template in pack.templates">
                      <li>{{template.name}}</li>
                    </ul>
                  </td>
                  <td>
                    <div class="btn-group">
                      <a class="btn btn-sm btn-primary" @click.prevent="editRecord(pack)" href="#"><font-awesome-icon icon="fas fa-edit" /></a>
                      <a class="btn btn-sm btn-danger" @click.prevent="deleteRecord(pack.id)" href="#"><font-awesome-icon icon="fas fa-trash" /></a>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="4">
                    Нет данных для отображения
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <nav class="justify-content-between d-flex mt-2 align-items-center">
          <div class="p-2">
            <label for="inputState" class="form-label mb-0">На странице: </label>
            <select class="form-select" v-model="perPage" @change="changePerPage()">
              <option :value="value" v-for="value in perPageList">{{value}}</option>
            </select>
          </div>
          <ul class="pagination mb-0">
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(firstPage)" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-fast-backward" /> Первая
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="prevPage()" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-step-backward" /> Предыдущая
              </a>
            </li>
            <li class="page-item" :class="{ 'active': page.active }" v-for="page in visiblePages">
              <a class="page-link" @click.prevent="selectPage(page.name)" href="#">{{page.name}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="nextPage()" href="#">
                Следующая <font-awesome-icon class="ml-1" icon="fas fa-step-forward" />
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(lastPage)" href="#">
                Последняя <font-awesome-icon class="ml-1" icon="fas fa-fast-forward" />
              </a>
            </li>
          </ul>
          <div class="p-2">
            <p class="mb-0">(Всего страниц: {{lastPage}})</p>
          </div>
        </nav>

      </div>
    </div>

    <!-- Field Add/Edit Modal -->
    <div class="modal modal-slide-in fade" id="addNewRecord" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content pt-0">
        <div class="modal-header mb-1">
          <h5 class="modal-title" v-show="!editmode">Добавить</h5>
          <h5 class="modal-title" v-show="editmode">Редактировать</h5>
        </div>
        <form @submit.prevent="editmode ? updateRecord() : createRecord()">
            <div class="modal-body" v-if="templates.length > 0">
              <div class="form-group">
                <label>Наименование</label>
                <input v-model="recordform.name" type="text" placeholder="Наименование" class="form-control" required>
              </div>

              <div class="form-check form-check-inline mt-2" v-for="(template, index) in templates">
                <input :id="'check_'+index" type="checkbox" class="form-check-input" v-model="recordform.packs[template.id]" />
                <label :for="'check_'+index" class="form-check-label">{{template.name}} ({{template.description}})</label>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
              <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
              <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->

  </div>
</template>

<script>
  export default {
    props: ['id', 'project'],
    computed: {
      startPage() {
        if (this.currentPage < 4) {
          return 1;
        }
        if (this.currentPage == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 1) == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 2) == this.lastPage) {
          return this.startPage2;
        }
        return this.currentPage - 3;
      },
      startPage2(){
        if(this.lastPage > 6){
          return this.lastPage - 6;
        }
        if(this.lastPage > 5){
          return this.lastPage - 5;
        }
        if(this.lastPage > 4){
          return this.lastPage - 4;
        }
        if(this.lastPage > 3){
          return this.lastPage - 3;
        }
        if(this.lastPage > 2){
          return this.lastPage - 2;
        }
      },
      visiblePages() {
        let pages = [];
        let start = this.startPage;
        let end = Math.min(this.startPage + 6, this.lastPage);
        for (let i = start; i <= end; i++) {
          pages.push({
            name: i,
            active: i == this.currentPage
          });
        }
        return pages;
      }
    },
    data () {
      return {
        searchQuery: '',
        currentPage: 1,
        lastPage: 1,
        firstPage: 1,
        timeout: null,
        perPage: 10,
        perPageList: [10, 25, 50, 100],
        packs: [],
        templates: [],
        recordform: new Form({
          id: null,
          name: null,
          packs: []
        }),
        editmode: false,
      }
    },
    methods: {
      SuccessToast(){
        Toast.fire({
          icon: 'success',
          title: 'Успешно'
        });
      },
      ErrorToast(){
        Toast.fire({
          icon: 'error',
          title: 'Ошибка'
        });
      },
      editRecord(record){
        this.editmode = true;
        this.recordform.reset();
        this.recordform.id = record.id;
        this.recordform.name = record.name;

        record.templates.forEach(item => {
          this.recordform.packs[item.id] = true;
        });


        $('#addNewRecord').modal('show');
      },
      newRecord(){
        this.editmode = false;
        this.recordform.reset();
        $('#addNewRecord').modal('show');
      },
      nextPage(){
        if(this.currentPage < this.lastPage){
          this.currentPage++;
          this.loadRecords();
        }
      },
      selectPage(number){
        this.currentPage = number;
        this.loadRecords();
      },
      prevPage(){
        if(this.currentPage > 1){
          this.currentPage--;
          this.loadRecords();
        }
      },
      search(){
        if(this.timeout)
          clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.$Progress.start();
          this.currentPage = 1;
          this.loadRecords();
          this.$Progress.finish();
        }, 500);

      },
      changePerPage(){
        this.currentPage = 1;
        this.loadRecords();
      },
      createRecord(){
        this.$Progress.start();
        this.recordform.post('/api/project/'+this.id+'/pack')
        .then((response)=>{
          $('#addNewRecord').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.recordform.reset();
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      updateRecord(){
        this.$Progress.start();
        this.recordform.put('/api/project/'+this.id+'/pack/'+this.recordform.id)
        .then((response) => {
          $('#addNewRecord').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.recordform.reset();
          this.$Progress.finish();
        })
        .catch(() => {
          this.ErrorToast();
          this.$Progress.fail();
        });
      },
      deleteRecord(id){
        Swal.fire({
          title: 'Вы уверены?',
          text: "Это действие нельзя будет отменить",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          cancelButtonText: 'Отмена',
          confirmButtonText: 'Да, удалить'
          }).then((result) => {
           if (result.value) {
            this.recordform.delete('/api/project/'+this.id+'/pack/'+id).then(()=>{
              this.SuccessToast();
              this.loadRecords();
            }).catch((data)=> {
              this.ErrorToast();
            });
          }
        })
      },
      loadRecords(){
        axios.get('/api/project/'+this.id+'/pack?page='+this.currentPage+'&search='+this.searchQuery+'&perPage='+this.perPage).then(({ data }) => {
          this.packs = data.data;
          this.lastPage = data.last_page;
        });
      },
      loadTemplates(){
        axios.get('/api/project/'+this.id+'/template?page=1&search=&perPage=1000').then(({ data }) => {
          this.templates = data.data;
        });
      }
    },
    created() {
      this.$Progress.start();
      this.loadRecords();
      this.loadTemplates();
      this.$Progress.finish();
    }
  }
</script>
